/* eslint-disable flowtype/require-valid-file-annotation */
/* eslint-disable react/no-array-index-key */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';
import { withStyles } from '@material-ui/core/styles';

import renderInput from './input';
import renderSuggestion from './suggestion';
import renderSuggestionsContainer from './suggestions-container';

// function getSuggestions(value) {
//   if (this.props.getSuggestions) {
//     return this.props.getSuggestions(value);
//   }
//
//   const inputValue = value.trim().toLowerCase();
//   const inputLength = inputValue.length;
//   let count = 0;
//
//   return inputLength === 0
//     ? []
//     : suggestions.filter(suggestion => {
//         const keep =
//           count < 5 &&
//           suggestion.label.toLowerCase().slice(0, inputLength) === inputValue;
//
//         if (keep) {
//           count += 1;
//         }
//
//         return keep;
//       });
// }

function getSuggestionValue(suggestion) {
  return suggestion.label;
}

const styles = theme => ({
  container: {
    flexGrow: 1,
    position: 'relative'
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
    top: 50,
    left: 0,
    right: 0,
    zIndex: 100
  },
  suggestion: {
    display: 'block'
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none'
  },
  textField: {
    width: '100%'
  }
});

class Autocomplete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value || props.defaultValue || '',
      suggestions: []
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { reset = false } = nextProps;
    if (reset !== this.props.reset) {
      this.setState({ value: '' });
    }
  }

  handleSuggestionsFetchRequested = async ({ value }) => {
    const suggestions = await this.props.getSuggestions(value);
    this.setState({ suggestions });
  };

  handleSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  handleChange = (event, { newValue }) => {
    this.setState({
      value: newValue
    });
  };

  render() {
    const {
      classes,
      getSuggestions, // eslint-disable-line no-unused-vars
      inputProps = {},
      error,
      ...props
    } = this.props;

    if (error) {
      inputProps.helperText = error;
    }
    return (
      <Autosuggest
        theme={{
          container: classes.container,
          suggestionsContainerOpen: classes.suggestionsContainerOpen,
          suggestionsList: classes.suggestionsList,
          suggestion: classes.suggestion
        }}
        renderInputComponent={renderInput}
        suggestions={this.state.suggestions}
        onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
        renderSuggestionsContainer={renderSuggestionsContainer}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={{
          // autoFocus: true,
          error: Boolean(error),
          classes,
          value: this.state.value,
          onChange: this.handleChange,
          ...inputProps
        }}
        {...props}
      />
    );
  }
}

Autocomplete.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Autocomplete);
